import { Tag } from "antd";
import { ReactNode } from "react";

interface Props {
    title: string;
    icon: ReactNode;
    items: string[];
}
const CategoryFocusltem = (props: Props) => {
    return (
        <div className="rounded-[8px] border border-[#E4E7EC] p-[16px]">
            <div className="flex items-center gap-x-[8px] mb-[16px]">
                {props?.icon}
                <p className="text-[13px] font-[500] m-0">{props.title}</p>
            </div>
            <div className="flex flex-wrap gap-y-[8px]">
                {props.items?.map((item: string, index: number) => (
                    <Tag bordered={false} key={index}>{item}</Tag>
                ))}
            </div>

        </div>
    )
}

export default CategoryFocusltem